import { Box, Grid, SxProps, Theme, Typography, FormControlLabel, Switch } from '@mui/material';
import FilterAltSharpIcon from '@mui/icons-material/FilterAltSharp';
import { TableInstance } from 'react-table';
import { ContractReviewGridItem } from 'shared/types';
import {
  ContractApprovalWorkflowTableFilters,
  useContractApprovalWorkflowListState,
} from 'shared/contexts/contract-approval-workflow-filter-context';
import { useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'shared/hooks';

const infoWidgetContentStyles: SxProps<Theme> = {
  padding: 1,
};

const widgetContainerStyes: SxProps<Theme> = {
  backgroundColor: '#eeeeee',
};

interface Props {
  contractReviewTableInstance: TableInstance<ContractReviewGridItem>;
}

export function ContractReviewTableFilters({ contractReviewTableInstance }: Props) {
  const { gotoPage } = contractReviewTableInstance;
  const { setContractApprovalWorkflowTableState, formFilters } = useContractApprovalWorkflowListState();
  const [formFilterState, setFormFilterState] = useState<ContractApprovalWorkflowTableFilters>(formFilters);

  const debouncedSearch = useDebounce(formFilterState, 500);
  useEffect(() => {
    setContractApprovalWorkflowTableState(prevState => {
      return {
        ...prevState,
        tableFilters: debouncedSearch,
        tableState: {
          ...prevState.tableState,
          pageIndex: 0,
        },
      };
    });
    gotoPage(0);
  }, [debouncedSearch, setContractApprovalWorkflowTableState, gotoPage]);

  useEffect(() => {
    setFormFilterState(formFilters);
  }, [formFilters]);

  const handleShowTermsOrTiersClicked = useCallback(() => {
    setFormFilterState({
      ...formFilterState,
      showTermOrTierChanges: !formFilterState.showTermOrTierChanges,
    });
  }, [setFormFilterState, formFilterState]);

  const handleShowDeletionOrRestorationClicked = useCallback(() => {
    setFormFilterState({
      ...formFilterState,
      showDeletionsOrRestorations: !formFilterState.showDeletionsOrRestorations,
    });
  }, [setFormFilterState, formFilterState]);

  return (
    <Box sx={{ paddingBottom: 1 }}>
      <Box sx={widgetContainerStyes}>
        <Grid container sx={infoWidgetContentStyles}>
          <Grid container item xs={12} spacing={1} sx={{ margin: 0.5 }}>
            <Grid item xs={0.5} sx={{ display: 'flex', justifyContent: 'center', flexFlow: 'column' }}>
              <FilterAltSharpIcon />
            </Grid>
            <Grid item xs={1.5} sx={{ display: 'flex', justifyContent: 'center', flexFlow: 'column' }}>
              <Typography variant='body2'>Page Filters</Typography>
            </Grid>
            <Grid item xs={5}>
              <FormControlLabel
                control={
                  <Switch onChange={handleShowTermsOrTiersClicked} checked={formFilterState.showTermOrTierChanges} />
                }
                label='Show Items with Term or Tier Changes'
              />
            </Grid>
            <Grid item xs={5}>
              <FormControlLabel
                control={
                  <Switch
                    onChange={handleShowDeletionOrRestorationClicked}
                    checked={formFilterState.showDeletionsOrRestorations}
                  />
                }
                label='Show Items Marked For Deletion or Restoration'
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
